import { SAGE_ICON } from "common/constants"
import { TFunction } from "i18next"

export interface Integration {
  title: string
  text: string
  logo: string
}

export function INTEGRATIONS_LIST(t: TFunction): Integration[] {
  return [
    {
      title: `${t("integracion.list.sage")}`,
      text: `${t("integracion.list.sageText")}`,
      logo: SAGE_ICON,
    },
  ]
}
